import CreditCardItem from './CreditCardItem';
import { PatientCreditCard } from '@qmd-types/patient';
import {
  Button,
  CloseIcon,
  Paragraph,
  PlusIcon,
} from '@quickmd-llc/design-system';

interface Props {
  creditCards: PatientCreditCard[];
  handleAddCard: () => void;
  handleClose: () => void;
  selectedCreditCardId: string;
  setSelectedCreditCard: (creditCard: PatientCreditCard) => void;
}

export default function CreditCardsList({
  creditCards,
  handleAddCard,
  handleClose,
  selectedCreditCardId,
  setSelectedCreditCard,
}: Props): JSX.Element {
  function handleSelectCard(creditCard: PatientCreditCard) {
    setSelectedCreditCard(creditCard);
    handleClose();
  }

  const maxCardsReached = creditCards.length > 9;
  return (
    <div className="flex max-h-[90vh] max-w-lg flex-1 flex-col self-end rounded-lg bg-white p-6 lg:self-center">
      <div className="mb-4 flex flex-row items-center justify-between">
        <Paragraph className="text-base font-semibold lg:text-2xl">
          Payment Method
        </Paragraph>
        <CloseIcon className="cursor-pointer" onClick={handleClose} />
      </div>

      <div className="g-1 flex flex-1 flex-col justify-between overflow-x-scroll rounded-lg bg-white">
        {creditCards.map((creditCard) => (
          <CreditCardItem
            creditCard={creditCard}
            selectedId={selectedCreditCardId}
            handleSelectCard={handleSelectCard}
            key={creditCard.id}
          />
        ))}
      </div>
      <Button
        className="mt-2"
        priority="secondary"
        onClick={handleAddCard}
        disabled={maxCardsReached}
      >
        <PlusIcon /> Add Card
      </Button>
      {maxCardsReached && (
        <Paragraph className="mt-2 font-poppins text-xs font-normal text-shade-80">
          Maximum cards reached. You can manage your payment methods in your
          Account Settings.
        </Paragraph>
      )}
    </div>
  );
}
